// C:\MonProjet\BBW_DELEGUER\preprod\babyworld-backoffice\babyworld-backoffice\src\pages\doctors\DoctorsPage\index.js

import React, { useEffect, useState, useCallback } from "react";
import { useHistory } from "react-router-dom";
import { 
  PlusOutlined, UploadOutlined, DownloadOutlined, 
  FolderViewOutlined, AuditOutlined, UserOutlined, 
  RocketOutlined, FileSearchOutlined, EnvironmentOutlined,
  EditOutlined, DeleteOutlined, StarFilled, ScheduleOutlined, CrownOutlined,
  WarningOutlined, CheckCircleOutlined
} from "@ant-design/icons";
import { unwrapResult } from '@reduxjs/toolkit';
import { 
  Button, Card, Col, Row, Space, Table, Upload, Input, 
  Modal, Spin, Tag, Typography, Form, Select, List, Popconfirm,
  Collapse, Badge, Tooltip
} from "antd"; 
import Filter from "../../../components/filter/Filter";
import { useDispatch, useSelector } from "react-redux";
import ArchivedModal from "./ArchivedModal";
import {
  deletePerson,
  getPersonByType,
  exportPersons,
  updatePerson 
} from "../../../redux/slices/persons/personsThunk";
import { getSpecialtiesForFilter } from "../../../redux/slices/specialtys/specialtysThunk";
import { getGovernments } from "../../../redux/slices/governments/governmentsThunk";
import { getRegions } from "../../../redux/slices/regions/regionsThunk";
import { toast } from "react-toastify";
import { columns } from "./columns";
import { uploadDoctorFile } from "../../../redux/slices/importDoctors/importPersonsThunk";
import ImportComponent from "../../../components/logModal";
import CorrectionRequestsModal from "./CorrectionRequestsModal";
import axiosInstance from "../../../services/axiosServicesVisit";
import { getDelegatesList } from "../../../redux/slices/delegates/delegatesThunk";
import dayjs from "dayjs";

const { Text, Title } = Typography;

const DoctorsPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  
  const [commentForm] = Form.useForm();

  // --- DONNÉES REDUX ---
  const persons_data = useSelector((state) => state.persons.persons);
  const persons_loading = useSelector((state) => state.persons.loading);
  const governmentsData = useSelector((state) => state.governments.governments);
  const specialtysData = useSelector((state) => state.specialtys.specialtiesList);
  const regionsData = useSelector((state) => state.regions?.regions || []);
  const delegatesListData = useSelector((state) => state.delegates.delegatesList?.data?.data || []);

  // --- ÉTATS LOCAUX ---
  const [filter, setFilter] = useState({ doctorType: "", region: [], specialty: [], government: [], assignmentStatus: "all", isPartner: "" });
  const [searchTerm, setSearchTerm] = useState("");
  const [ids, setIds] = useState({ region: [], specialty: [], government: [] });
  const [pagination, setPagination] = useState({ currentPage: 1, pageSize: 10 });
  const [showLog, setShowLog] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [isArchiveModalVisible, setIsArchiveModalVisible] = useState(false);
  const [isCorrectionModalVisible, setIsCorrectionModalVisible] = useState(false);

  // --- ÉTATS ARCHIVAGE AVEC MOTIF ---
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [itemId, setCitemId] = useState(null);
  const [archiveReason, setArchiveReason] = useState("");
  const [customArchiveReason, setCustomArchiveReason] = useState("");
  const [archiveLoading, setArchiveLoading] = useState(false);

  // --- ÉTATS POUR LE COMMENTAIRE ADMIN ---
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [selectedPersonForComment, setSelectedPersonForComment] = useState(null);

  // --- ÉTATS POUR L'HISTORIQUE MÉDECIN ---
  const [doctorModalVisible, setDoctorModalVisible] = useState(false);
  const [doctorDetailData, setDoctorDetailData] = useState([]);
  const [doctorLoading, setDoctorLoading] = useState(false);

  const [isImportModalVisible, setIsImportModalVisible] = useState(false); 
  const [fileList, setFileList] = useState([]);

  // --- HANDLERS ---
  const handleShowLog = () => setShowLog(!showLog);
  const handlePageChange = (page, pageSize) => setPagination({ pageSize, currentPage: page });

  const showModal = (id) => { 
    setIsModalOpen(true); 
    setCitemId(id); 
    setArchiveReason("");
    setCustomArchiveReason("");
  };

  const createOptions = (data, labelKey = "name", idKey = "id") => {
    const list = Array.isArray(data) ? data : (data?.data || []);
    return list.map((item) => {
      let label = item[labelKey];
      if (item.firstname || item.lastname) {
        label = `${item.firstname || ''} ${item.lastname || ''}`.trim();
      }
      return { id: item[idKey], label: label || `ID: ${item[idKey]}`, value: item[idKey] };
    });
  };

  const optionsLists = [
    { name: "Spécialités", placeholder: "Spécialités", key: "specialty", multiple: true, options: createOptions(specialtysData) },
    { name: "Gouvernorat", placeholder: "Gouvernorat", key: "government", multiple: true, options: createOptions(governmentsData?.data) },
    { name: "Région", placeholder: "Région", key: "region", multiple: true, options: createOptions(regionsData?.data || regionsData) },
    { name: "Délégués", placeholder: "Délégués assignés", key: "delegates", multiple: true, options: createOptions(delegatesListData) },
    { name: "Assignation", placeholder: "Statut", key: "assignmentStatus", multiple: false, options: [{ label: "Tous", value: "all" }, { label: "Assigné", value: "assigned" }, { label: "Non assigné", value: "unassigned" }] },
    { 
      name: "Type Médecin", 
      placeholder: "Type (Privé/Hosp)", 
      key: "doctorType", 
      multiple: false, 
      options: [
        { label: "Tous", value: "" }, 
        { label: "Hospitalier", value: 1 }, 
        { label: "Privé", value: 2 }
      ] 
    },
    {
      name: "Partenaire",
      placeholder: "Statut Partenaire",
      key: "isPartner",
      multiple: false,
      options: [
        { label: "Tous", value: "" },
        { label: "⭐ Partenaires", value: "true" },
        { label: "Standard", value: "false" }
      ]
    },
  ];

  useEffect(() => {
    dispatch(getGovernments({ page: 1, limit: 100 }));
    dispatch(getSpecialtiesForFilter());
    dispatch(getRegions({ page: 1, itemsPerPage: 1000 }));
    dispatch(getDelegatesList({ page: 1, itemsPerPage: 1000 })); 
  }, [dispatch]);

  const refreshDoctorsList = useCallback(() => {
    dispatch(getPersonByType({
      type: 1,
      pageNumber: pagination.currentPage,
      limit: pagination.pageSize,
      filter: { ...filter, ...ids, search: searchTerm },
    }));
  }, [dispatch, pagination, filter, ids, searchTerm]);
  
  useEffect(() => { refreshDoctorsList(); }, [refreshDoctorsList]);

  // SAUVEGARDE DU COMMENTAIRE ADMINISTRATIF
  const handleSaveComment = (values) => {
    const newEntry = `${dayjs().format('DD/MM/YYYY')} [${values.commercial}] : ${values.note}`;
    const existingComments = selectedPersonForComment.adminComment || "";
    const finalComment = existingComments 
      ? `${newEntry}\n${existingComments}` 
      : newEntry;
    
    dispatch(updatePerson({
      personId: selectedPersonForComment.id,
      personData: { adminComment: finalComment }
    })).then(() => {
      toast.success("Commentaire ajouté à l'historique");
      setIsCommentModalOpen(false);
      commentForm.resetFields();
      refreshDoctorsList();
    });
  };

  const handleDeleteCommentEntry = (record, indexToDelete) => {
    const currentEntries = record.adminComment.split('\n').filter(Boolean);
    const updatedEntries = currentEntries.filter((_, i) => i !== indexToDelete);
    const newCommentString = updatedEntries.length > 0 ? updatedEntries.join('\n') : null;

    dispatch(updatePerson({
      personId: record.id,
      personData: { adminComment: newCommentString }
    })).then(() => {
      toast.success("Entrée supprimée");
      refreshDoctorsList();
    });
  };

  const handleOpenDoctorHistory = async (personId) => {
    setDoctorModalVisible(true);
    setDoctorLoading(true);
    try {
      const res = await axiosInstance.get(`/v1/delegate-stocks/analytics/doctor-full-details`, {
        params: { personId, startDate: '2020-01-01', endDate: dayjs().format('YYYY-MM-DD'), _t: Date.now() }
      });
      setDoctorDetailData(res.data || []);
    } catch (e) { toast.error("Erreur chargement historique"); }
    finally { setDoctorLoading(false); }
  };

  const handleExportDoctorHistory = () => {
    if (doctorDetailData.length === 0) return;
    const docName = doctorDetailData[0].doctorName;
    const headers = ["Date", "Region", "Delegue Visiteur", "Type", "Echantillons", "Produits", "Observations / Note"];
    const rows = doctorDetailData.map(item => {
      const isSupervisor = (item.note && (item.note.includes('[RAPPORT SUPERVISEUR') || item.note.includes('[VISITE DE CONTRÔLE') || item.note.includes('[SUPERVISION'))) ||
                           (item.name && item.name.includes('[SUPERVISEUR]'));
      return [
        dayjs(item.reportDate).format('DD/MM/YYYY HH:mm'),
        item.regionName || "N/A",
        item.delegateName,
        isSupervisor ? "Superviseur" : "Délégué",
        item.samples?.map(s => `${s.name} (x${s.quantity})`).join(' | '),
        item.products?.join(' | '),
        `"${(item.note || item.comment || '').replace(/"/g, '""')}"`
      ];
    });
    const csvContent = [headers, ...rows].map(e => e.join(";")).join("\n");
    const blob = new Blob(["\ufeff" + csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = `Parcours_${docName.replace(/\s+/g, '_')}.csv`;
    link.click();
  };

  const handleExport = () => {
    setExporting(true);
    dispatch(exportPersons({ 
      type: 1, 
      format: 'csv', 
      filter: { ...filter, ...ids, search: searchTerm } 
    }))
    .unwrap()
    .catch((err) => toast.error("Erreur lors de l'export : " + err))
    .finally(() => setExporting(false));
  };

  const handleUploadCSV = () => {
    if (fileList.length === 0) return toast.error("Veuillez sélectionner un fichier.");
    const formData = new FormData();
    formData.append('file', fileList[0].originFileObj || fileList[0]);
    setIsImportModalVisible(false);
    setShowLog(true);
    dispatch(uploadDoctorFile(formData))
      .then(unwrapResult)
      .then(() => {
        setShowLog(false);
        toast.success("Importation terminée !");
        setFileList([]);
        refreshDoctorsList();
      })
      .catch((err) => {
        setShowLog(false);
        toast.error("Erreur d'importation : " + err);
      });
  };

  // HANDLER SUPPRESSION / ARCHIVAGE AVEC MOTIF
  const handelDelete = () => {
    if (!archiveReason) {
      toast.warning("Veuillez sélectionner un motif d'archivage.");
      return;
    }

    const finalReason = archiveReason === "Autre" 
      ? (customArchiveReason.trim() ? `Autre: ${customArchiveReason.trim()}` : "Autre motif") 
      : archiveReason;

    setArchiveLoading(true);
    dispatch(deletePerson({ id: itemId, reason: finalReason })).then((result) => {
      setArchiveLoading(false);
      if (result.meta.requestStatus === "fulfilled") {
        toast.success("Médecin archivé avec succès");
        setIsModalOpen(false);
        refreshDoctorsList();
      } else {
        toast.error("Erreur lors de l'archivage");
      }
    });
  };

  return (
    <div className="tabled">
      <Row gutter={[24, 0]}>
        <Col xs="24" xl={24}>
          <Card bordered={false} className="criclebox tablespace mb-24" title="Liste des médecins" extra={
              <Space>
                <Button icon={<DownloadOutlined />} onClick={handleExport} loading={exporting}>Exporter</Button>
                <Button type="primary" icon={<UploadOutlined />} onClick={() => setIsImportModalVisible(true)}>Importer</Button>
                <Button icon={<AuditOutlined />} onClick={() => setIsCorrectionModalVisible(true)} style={{ color: '#faad14' }}>Suggestions</Button>
                <Button icon={<FolderViewOutlined />} onClick={() => setIsArchiveModalVisible(true)}>Archives</Button>
                <Button type="primary" onClick={() => history.push("/nouveau/médecin")} icon={<PlusOutlined />}>Ajouter</Button>
              </Space>
            }
          />
          <Card bordered={false} className="criclebox tablespace mb-24">
            <div style={{ padding: "0 24px 24px" }}>
              <Space direction="vertical" style={{ width: '100%' }}>
                  <Input.Search placeholder="Rechercher..." onSearch={val => setSearchTerm(val)} onChange={e => setSearchTerm(e.target.value)} allowClear value={searchTerm} />
                  <Filter optionsLists={optionsLists} onSelect={(val, key, id) => {
                      setFilter(prev => ({ ...prev, [key]: val }));
                      if(id) setIds(prev => ({ ...prev, [key]: id }));
                      setPagination(prev => ({ ...prev, currentPage: 1 }));
                  }} data={filter} />
              </Space>
            </div>
            <Table
              columns={columns(p => history.push(p), showModal, handleOpenDoctorHistory)}
              dataSource={persons_data?.data}
              loading={persons_loading}
              rowKey="id"
              rowClassName={(record) => record.isPartner ? 'row-partner-gold' : ''}
              pagination={{ current: pagination.currentPage, total: persons_data?.total, onChange: handlePageChange }}
              scroll={{ x: 2000 }} 
              expandable={{
              expandedRowRender: (record) => (
                <div style={{ margin: 0, padding: '15px 50px', background: '#f0f5ff', borderRadius: '4px' }}>
                  <Row gutter={24}>
                    <Col span={18}>
                      {/* 1. SECTION CODE */}
                      <div style={{ marginBottom: '12px' }}>
                        <Text strong>Code : </Text>
                        <Tag color="cyan" style={{ fontSize: '14px', fontWeight: 'bold' }}>{record.code || 'Non généré'}</Tag>
                      </div>

                      {/* 2. SECTION HISTORIQUE DE SUIVI (COMMERCIAUX) */}
                      <div style={{ marginBottom: '16px' }}>
                        <Text strong style={{ color: '#1890ff', display: 'block', marginBottom: '8px' }}>
                          Historique de suivi :
                        </Text>
                        {record.adminComment ? (
                          <List
                            size="small"
                            bordered
                            style={{ background: '#fff', borderRadius: '4px' }}
                            dataSource={record.adminComment.split('\n').filter(Boolean)}
                            renderItem={(item, index) => (
                              <List.Item
                                style={{ fontSize: '13px' }}
                                actions={[
                                  <Popconfirm
                                    title="Supprimer cette note ?"
                                    onConfirm={() => handleDeleteCommentEntry(record, index)}
                                    okText="Oui"
                                    cancelText="Non"
                                  >
                                    <DeleteOutlined style={{ color: '#ff4d4f', cursor: 'pointer' }} />
                                  </Popconfirm>
                                ]}
                              >
                                {item}
                              </List.Item>
                            )}
                          />
                        ) : (
                          <Text type="secondary" italic style={{ fontSize: '12px' }}>
                            Aucun commentaire administratif pour ce médecin.
                          </Text>
                        )}
                      </div>

                      {/* --- BLOC ACCORDÉON : CYCLES ET SEMAINES DE PLANIFICATION --- */}
                      <div style={{ marginBottom: '16px' }}>
                        <Collapse
                          ghost
                          style={{ 
                            background: '#ffffff', 
                            borderRadius: '6px', 
                            border: '1px solid #d6e4ff' 
                          }}
                          items={[
                            {
                              key: 'cycles_plan',
                              label: (
                                <Space>
                                  <ScheduleOutlined style={{ color: '#0e519b', fontSize: '15px' }} />
                                  <Text strong style={{ color: '#0e519b' }}>
                                    Cycles et Semaines de planification
                                  </Text>
                                  <Badge 
                                    count={record.assignedCycles?.length || 0} 
                                    style={{ 
                                      backgroundColor: record.assignedCycles?.length > 0 ? '#1890ff' : '#d9d9d9',
                                      marginLeft: 6 
                                    }} 
                                  />
                                </Space>
                              ),
                              children: (
                                <div>
                                  {record.assignedCycles && record.assignedCycles.length > 0 ? (
                                    <Space wrap size={[8, 8]}>
                                      {record.assignedCycles.map((c, i) => (
                                        <Tag 
                                          key={i} 
                                          color="geekblue" 
                                          style={{ 
                                            padding: '4px 10px', 
                                            borderRadius: '4px',
                                            fontSize: '12px'
                                          }}
                                        >
                                          <b>{c.cycleName}</b> - <span style={{ color: '#1890ff', fontWeight: 600 }}>Semaine {c.weekNumber}</span>{' '}
                                          <span style={{ color: '#595959', fontSize: '11px' }}>
                                            ({dayjs(c.startDate).format('DD/MM/YY')} au {dayjs(c.endDate).format('DD/MM/YY')})
                                          </span>
                                          {c.delegateName && (
                                            <Tag color="purple" style={{ marginLeft: 6, fontSize: '10px' }}>
                                              {c.delegateName}
                                            </Tag>
                                          )}
                                        </Tag>
                                      ))}
                                    </Space>
                                  ) : (
                                    <Text type="secondary" italic style={{ fontSize: '12px' }}>
                                      Ce médecin n'est planifié dans aucun cycle actuellement.
                                    </Text>
                                  )}
                                </div>
                              )
                            }
                          ]}
                        />
                      </div>

                      {/* 3. SECTION : HISTORIQUE PARTENAIRE (SI PARTENAIRE) */}
                      {record.isPartner && (
                        <div style={{ marginTop: '16px', paddingTop: '16px', borderTop: '1px dashed #ffe58f' }}>
                          <Text strong style={{ color: '#d4b106', display: 'block', marginBottom: '8px' }}>
                            <StarFilled /> Historique Partenaire :
                          </Text>
                          {record.partnerNotes ? (
                            <List
                              size="small"
                              bordered
                              style={{ background: '#fffbe6', borderRadius: '4px', border: '1px solid #ffe58f' }}
                              dataSource={record.partnerNotes.split('\n').filter(Boolean)}
                              renderItem={(item) => (
                                <List.Item style={{ fontSize: '13px', color: '#856404' }}>
                                  {item}
                                </List.Item>
                              )}
                            />
                          ) : (
                            <Text type="secondary" italic style={{ fontSize: '12px' }}>
                              Aucune note partenaire enregistrée pour ce médecin.
                            </Text>
                          )}
                        </div>
                      )}
                    </Col>

                    <Col span={6} style={{ textAlign: 'right' }}>
                      <Button 
                        size="small" 
                        type="primary"
                        ghost
                        icon={<EditOutlined />} 
                        onClick={() => {
                          setSelectedPersonForComment(record);
                          setIsCommentModalOpen(true);
                        }}
                      >
                        Ajouter une note de suivi
                      </Button>
                    </Col>
                  </Row>
                </div>
              ),
              rowExpandable: (record) => true,
            }}
            />

            <style>{`
              .row-partner-gold {
                background-color: #fffbe6 !important;
              }
              .row-partner-gold:hover > td {
                background-color: #fff1b8 !important;
              }
              .row-partner-gold td {
                background-color: #fffbe6 !important;
              }
              .row-partner-gold:hover td {
                background-color: #fff1b8 !important;
              }
              .row-partner-gold a {
                color: #856404 !important;
              }
            `}</style>
          </Card>
        </Col>

        {/* MODALE HISTORIQUE MÉDECIN */}
        <Modal 
          title={ 
            <div style={{ display: 'flex', justifyContent: 'space-between', width: '95%', alignItems: 'center' }}> 
              <span><AuditOutlined /> Parcours de visite du Médecin</span> 
              <Button 
                icon={<DownloadOutlined />} 
                size="small" 
                type="primary" 
                onClick={handleExportDoctorHistory} 
                disabled={doctorDetailData.length === 0}
              >
                Exporter Historique
              </Button> 
            </div> 
          } 
          open={doctorModalVisible} 
          onCancel={() => setDoctorModalVisible(false)} 
          footer={null} 
          width={1150} 
        >
          <Spin spinning={doctorLoading}>
            {doctorDetailData.length > 0 && (
              (() => {
                const firstRecord = doctorDetailData[0];
                const isPartner = firstRecord.isPartner === true || firstRecord.isPartner === 1 || firstRecord.isPartner === 'true';
                
                // ⚡ FILTRE : UNIQUEMENT LES CYCLES OUBLIÉS À PARTIR DE 2026
                const cyclesCoverage = (firstRecord.cyclesPlanningCoverage || []).map(cov => ({
                  ...cov,
                  unassignedCycles: (cov.unassignedCycles || []).filter(c => {
                    if (!c.startDate) return false;
                    return dayjs(c.startDate).year() >= 2026;
                  })
                }));

                const delegatesWithUnassigned = cyclesCoverage.filter(cov => (cov.unassignedCycles || []).length > 0);
                const totalOublisCount = delegatesWithUnassigned.reduce((acc, curr) => acc + (curr.unassignedCycles?.length || 0), 0);

                return (
                  <div>
                    {/* 1. FICHE RÉCAPITULATIVE DU MÉDECIN */}
                    <div style={{ 
                      marginBottom: 16, 
                      padding: '16px 20px', 
                      borderRadius: '10px', 
                      backgroundColor: isPartner ? '#fffbe6' : '#f0f5ff', 
                      border: isPartner ? '2px solid #fadb14' : '1px solid #adc6ff',
                      boxShadow: isPartner ? '0 4px 12px rgba(250, 219, 20, 0.15)' : 'none'
                    }}>
                      <Row gutter={[16, 16]} align="middle">
                        <Col span={16}>
                          <div style={{ display: 'flex', alignItems: 'flex-start', gap: '15px' }}>
                              <UserOutlined style={{ fontSize: '28px', marginTop: '5px', color: isPartner ? '#856404' : '#1890ff' }} />
                              <div>
                                  <div style={{ display: 'flex', alignItems: 'center', gap: '12px', flexWrap: 'wrap' }}>
                                      <Title level={3} style={{ margin: 0, color: isPartner ? '#856404' : '#002766' }}>
                                          {firstRecord.doctorName}
                                      </Title>
                                      {isPartner && (
                                          <Tag color="gold" style={{ 
                                              fontSize: '13px', 
                                              fontWeight: '900', 
                                              border: '1px solid #d4b106', 
                                              borderRadius: '4px',
                                              padding: '2px 10px',
                                              textTransform: 'uppercase'
                                          }}>
                                              <StarFilled style={{ marginRight: '6px' }} /> MÉDECIN PARTENAIRE
                                          </Tag>
                                      )}
                                  </div>

                                  <Space wrap size={8} style={{ marginTop: '8px' }}>
                                      <Tag color="blue" style={{ fontWeight: 'bold' }}>{firstRecord.specialtyName}</Tag>
                                      <Text type="secondary"><EnvironmentOutlined /> {firstRecord.regionName || "N/A"}</Text>
                                      {firstRecord.address && <Text type="secondary">({firstRecord.address})</Text>}
                                  </Space>
                              </div>
                          </div>
                        </Col>

                        <Col span={8} style={{ 
                            textAlign: 'right', 
                            borderLeft: `2px solid ${isPartner ? '#fadb14' : '#adc6ff'}`, 
                            paddingLeft: '20px' 
                        }}>
                          <Text type="secondary" style={{ fontSize: '11px', display: 'block', marginBottom: '8px' }}>
                            Délégués assignés au portefeuille :
                          </Text>
                          <Space wrap size={[4, 8]}>
                            {firstRecord.assignedDelegates?.length > 0 ? (
                              firstRecord.assignedDelegates.map((name, idx) => (
                                <Tag key={idx} color="cyan" icon={<RocketOutlined />} style={{ borderRadius: '10px' }}>
                                  {name.toUpperCase()}
                                </Tag>
                              ))
                            ) : (
                              <Text type="secondary" italic style={{ fontSize: '11px' }}>Aucun délégué assigné</Text>
                            )}
                          </Space>
                        </Col>
                      </Row>
                    </div>

                    {/* 2. ⚡ ACCORDÉON DES OUBLIS DE PLANIFICATION PAR CYCLE (>= 2026) ⚡ */}
                    {cyclesCoverage.length > 0 && (
                      <div style={{ marginBottom: 16 }}>
                        <Collapse
                          defaultActiveKey={delegatesWithUnassigned.length > 0 ? ['audit_oubli'] : []}
                          style={{ 
                            background: delegatesWithUnassigned.length > 0 ? '#fff2f0' : '#f6ffed', 
                            border: delegatesWithUnassigned.length > 0 ? '1px solid #ffa39e' : '1px solid #b7eb8f',
                            borderRadius: '8px'
                          }}
                          items={[
                            {
                              key: 'audit_oubli',
                              label: (
                                <Space>
                                  {delegatesWithUnassigned.length > 0 ? (
                                    <>
                                      <WarningOutlined style={{ color: '#cf1322', fontSize: '16px' }} />
                                      <span style={{ color: '#cf1322', fontWeight: 'bold', fontSize: '13px' }}>
                                        Alertes Oublis de Planification par Cycle
                                      </span>
                                      <Badge count={`${totalOublisCount} cycle(s) oublié(s)`} style={{ backgroundColor: '#cf1322' }} />
                                    </>
                                  ) : (
                                    <>
                                      <CheckCircleOutlined style={{ color: '#52c41a', fontSize: '16px' }} />
                                      <span style={{ color: '#389e0d', fontWeight: 'bold', fontSize: '13px' }}>
                                        Planification Optimale : Ce médecin est planifié dans 100% des cycles
                                      </span>
                                      <Tag color="success" style={{ marginLeft: 8 }}>100% Couvert</Tag>
                                    </>
                                  )}
                                </Space>
                              ),
                              children: (
                                <div>
                                  {delegatesWithUnassigned.length > 0 ? (
                                    delegatesWithUnassigned.map((cov, idx) => {
                                      const unassignedList = cov.unassignedCycles || [];
                                      const assignedList = cov.assignedCycles || [];

                                      return (
                                        <div 
                                          key={idx} 
                                          style={{ 
                                            padding: '10px 14px', 
                                            background: '#ffffff', 
                                            borderRadius: '6px', 
                                            border: '1px solid #ffccc7',
                                            marginBottom: idx !== delegatesWithUnassigned.length - 1 ? 8 : 0 
                                          }}
                                        >
                                          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 6 }}>
                                            <Text strong style={{ color: '#1890ff', fontSize: '13px' }}>
                                              👤 Délégué : {cov.delegateName}
                                            </Text>
                                            <Tag color="default" style={{ fontSize: '11px', color: '#595959' }}>
                                              Planifié dans {assignedList.length} autre(s) cycle(s)
                                            </Tag>
                                          </div>

                                          <div>
                                            <Text strong style={{ fontSize: '12px', color: '#cf1322', display: 'block', marginBottom: 6 }}>
                                              ⚠️ NON ASSIGNÉ dans ces cycles ({unassignedList.length}) :
                                            </Text>
                                            <Space wrap size={[6, 8]}>
                                              {unassignedList.map((c, cIdx) => {
                                                const periodStr = c.startDate && c.endDate 
                                                  ? `(${dayjs(c.startDate).format('DD/MM/YY')} au ${dayjs(c.endDate).format('DD/MM/YY')})`
                                                  : '';

                                                return (
                                                  <Tag 
                                                    key={cIdx} 
                                                    color="error" 
                                                    style={{ 
                                                      fontWeight: 'bold', 
                                                      fontSize: '11px', 
                                                      padding: '3px 10px',
                                                      borderRadius: '4px' 
                                                    }}
                                                  >
                                                    ⚠️ {c.cycleName} <span style={{ fontWeight: 'normal', opacity: 0.9, marginLeft: 4 }}>{periodStr}</span>
                                                  </Tag>
                                                );
                                              })}
                                            </Space>
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <Text style={{ color: '#389e0d', fontSize: '12px' }}>
                                      Tous les délégués assignés ont bien planifié ce médecin dans l'ensemble de leurs cycles. Aucun oubli détecté.
                                    </Text>
                                  )}
                                </div>
                              )
                            }
                          ]}
                        />
                      </div>
                    )}
                  </div>
                );
              })()
            )}

            {/* 3. EN-TÊTE DU TABLEAU DES VISITES */}
            <div style={{ 
              background: '#f5f5f5', 
              padding: '10px 15px', 
              borderRadius: '6px', 
              marginBottom: '10px', 
              display: 'flex', 
              fontWeight: 'bold',
              fontSize: '12px',
              border: '1px solid #e8e8e8'
            }}>
              <div style={{ width: '15%' }}>Date & Heure</div>
              <div style={{ width: '20%' }}>Visiteur</div>
              <div style={{ width: '22%' }}>Échantillons distribués</div>
              <div style={{ width: '18%' }}>Produits présentés</div>
              <div style={{ width: '25%' }}>Observations / Notes</div>
            </div>

            {/* 4. LISTE DES VISITES AVEC IDENTIFICATION SUPERVISEUR */}
            <List 
              dataSource={doctorDetailData} 
              locale={{ emptyText: "Aucune visite trouvée pour ce médecin." }}
              renderItem={item => {
                const isSupervisor = item.isSupervisor || 
                  (item.note && (item.note.includes('[RAPPORT SUPERVISEUR') || item.note.includes('[VISITE DE CONTRÔLE') || item.note.includes('[SUPERVISION'))) ||
                  (item.name && (item.name.includes('[SUPERVISEUR]') || item.name.toLowerCase().includes('visite de contrôle')));

                let displayNote = item.note || item.comment || '';
                if (displayNote.includes('Observations :')) {
                  displayNote = displayNote.split('Observations :')[1].trim();
                }

                return (
                  <List.Item style={{ 
                    padding: '12px 15px', 
                    marginBottom: '8px',
                    borderRadius: '6px',
                    background: isSupervisor ? '#fcf6ff' : '#ffffff', 
                    border: isSupervisor ? '1px solid #d3adf7' : '1px solid #f0f0f0',
                    borderLeft: isSupervisor ? '5px solid #722ed1' : '1px solid #f0f0f0',
                    transition: 'all 0.2s'
                  }}>
                    <div style={{ display: 'flex', width: '100%', alignItems: 'center' }}>
                      <div style={{ width: '15%' }}>
                        <Text strong>{dayjs(item.reportDate).format('DD/MM/YYYY')}</Text>
                        <br/>
                        <Text type="secondary" style={{ fontSize: '11px' }}>{dayjs(item.reportDate).format('HH:mm')}</Text>
                      </div>

                      <div style={{ width: '20%' }}>
                        {isSupervisor ? (
                          <Tag color="purple" style={{ fontWeight: 'bold', padding: '3px 8px', borderRadius: '4px' }}>
                            <CrownOutlined style={{ marginRight: 5 }} /> {item.delegateName}
                          </Tag>
                        ) : (
                          <Tag icon={<UserOutlined />} color="default">
                            {item.delegateName}
                          </Tag>
                        )}
                      </div>

                      <div style={{ width: '22%' }}> 
                        {item.samples && item.samples.length > 0 ? (
                          item.samples.map((s, i) => (
                            <Tag 
                              key={i} 
                              color={s.isSpecific ? "error" : "processing"} 
                              style={{ marginBottom: '3px', fontSize: '11px' }}
                            >
                              {s.name} x{s.quantity}
                            </Tag>
                          ))
                        ) : (
                          <Text type="secondary" style={{ fontSize: '11px' }}>Aucun</Text>
                        )}
                      </div>

                      <div style={{ width: '18%' }}> 
                        {item.products && item.products.length > 0 ? (
                          item.products.map((p, i) => (
                            <Tag key={i} color="orange" style={{ marginBottom: '3px', fontSize: '11px' }}>{p}</Tag>
                          ))
                        ) : (
                          <Text type="secondary" style={{ fontSize: '11px' }}>-</Text>
                        )}
                      </div>

                      <div style={{ width: '25%' }}>
                        {displayNote ? (
                          <Tooltip title={item.note || displayNote}>
                            <div style={{ 
                              fontSize: '12px', 
                              color: isSupervisor ? '#531dab' : '#262626', 
                              background: isSupervisor ? '#f9f0ff' : '#f5f5f5',
                              padding: '5px 10px',
                              borderRadius: '4px',
                              border: isSupervisor ? '1px dashed #d3adf7' : '1px solid #e8e8e8',
                              maxHeight: '48px',
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                              whiteSpace: 'nowrap',
                              cursor: 'pointer'
                            }}>
                              📝 {displayNote}
                            </div>
                          </Tooltip>
                        ) : (
                          <Text type="secondary" style={{ fontSize: '11px' }}>-</Text>
                        )}
                      </div>
                    </div>
                  </List.Item>
                );
              }} 
            />
          </Spin>
        </Modal>

        {/* MODALE COMMENTAIRE ADMINISTRATIF */}
        <Modal
          title="Note Administrative / Commerciale"
          open={isCommentModalOpen}
          onCancel={() => setIsCommentModalOpen(false)}
          onOk={() => commentForm.submit()}
          okText="Enregistrer la note"
          cancelText="Annuler"
          destroyOnClose
        >
          <Form form={commentForm} layout="vertical" onFinish={handleSaveComment}>
            <Form.Item name="commercial" label="Commercial" rules={[{ required: true, message: 'Veuillez choisir un commercial' }]}>
              <Select placeholder="Choisir un trigramme">
                <Select.Option value="AN">AN</Select.Option>
                <Select.Option value="CHA">CHA</Select.Option>
                <Select.Option value="IBT">IBT</Select.Option>
                <Select.Option value="WCH">WCH</Select.Option>
              </Select>
            </Form.Item>
            <Form.Item name="note" label="Commentaire" rules={[{ required: true, message: 'Veuillez saisir un texte' }]}>
              <Input.TextArea rows={4} placeholder="Saisir les détails importants ici..." />
            </Form.Item>
          </Form>
        </Modal>

        {/* ⚡ MODALE D'ARCHIVAGE DU MÉDECIN AVEC LISTE DÉROULANTE DU MOTIF ⚡ */}
        <Modal
          title={
            <Space>
              <WarningOutlined style={{ color: '#faad14', fontSize: '18px' }} />
              <span style={{ fontWeight: 'bold' }}>Archiver le médecin</span>
            </Space>
          }
          open={isModalOpen}
          onCancel={() => setIsModalOpen(false)}
          onOk={handelDelete}
          okText="Confirmer l'archivage"
          okButtonProps={{ danger: true, loading: archiveLoading }}
          cancelText="Annuler"
          destroyOnClose
        >
          <div style={{ marginBottom: 16 }}>
            <Text>Voulez-vous vraiment archiver ce médecin ? Il ne sera plus visible dans la liste active.</Text>
          </div>

          <div style={{ marginBottom: 14 }}>
            <Text strong style={{ display: 'block', marginBottom: 6 }}>
              Motif de l'archivage <span style={{ color: 'red' }}>*</span> :
            </Text>
            <Select
              placeholder="Sélectionnez une raison..."
              style={{ width: '100%' }}
              value={archiveReason || undefined}
              onChange={(value) => setArchiveReason(value)}
              options={[
                { value: "Cessation d'activité / Retraite", label: "Cessation d'activité / Retraite" },
                { value: "Changement d'adresse / Hors secteur", label: "Changement d'adresse / Hors secteur" },
                { value: "Refus de visite / Non réceptif", label: "Refus de visite / Non réceptif" },
                { value: "Doublon / Erreur de saisie", label: "Doublon / Erreur de saisie" },
                { value: "Décès", label: "Décès" },
                { value: "Autre", label: "Autre motif" },
              ]}
            />
          </div>

          {archiveReason === "Autre" && (
            <div>
              <Text strong style={{ display: 'block', marginBottom: 6 }}>Précisez le motif :</Text>
              <Input.TextArea
                rows={2}
                placeholder="Indiquez les détails..."
                value={customArchiveReason}
                onChange={(e) => setCustomArchiveReason(e.target.value)}
              />
            </div>
          )}
        </Modal>

        <ImportComponent visible={showLog} onCancel={handleShowLog} />
        <ArchivedModal visible={isArchiveModalVisible} onClose={() => setIsArchiveModalVisible(false)} onRestoreSuccess={refreshDoctorsList} />
        <CorrectionRequestsModal visible={isCorrectionModalVisible} onClose={() => setIsCorrectionModalVisible(false)} />
        
        <Modal title="Importer la liste" open={isImportModalVisible} onOk={handleUploadCSV} onCancel={() => setIsImportModalVisible(false)} okText="Lancer" cancelText="Annuler">
          <Upload.Dragger accept=".csv" multiple={false} fileList={fileList} beforeUpload={(file) => { setFileList([file]); return false; }} onRemove={() => setFileList([])}>
            <p className="ant-upload-drag-icon"><FileSearchOutlined /></p>
            <p className="ant-upload-text">Cliquez ou glissez le fichier CSV ici</p>
          </Upload.Dragger>
        </Modal>
      </Row>
    </div>
  );
};

export default DoctorsPage;